import { createGlobalStyle } from "styled-components";

import TomarikTTF from '../assets/fonts/Tomarik-Brush.ttf';
import TomarikOTF from '../assets/fonts/Tomarik-Brush.otf';

  
export const Styles = createGlobalStyle`
    @font-face {
        font-family: 'Tomarik';
        font-weight: 400;
        font-style: normal;
        src: url(${TomarikTTF}) format('truetype');
    }

    @font-face {
        font-family: 'Tomarik';
        font-weight: 400;
        font-style: normal;
        src: url(${TomarikOTF}) format('opentype');
    }

    body,
    html,
    a {
        font-family: 'Oswald', sans-serif;
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: #5a42d2;
        overflow-x: hidden;
    }

    a:hover {
        color: #5a42d2;
        text-decoration: underline;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: rgb(241, 242, 243);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
            box-shadow: #2e186a 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Oswald', sans-serif;
        color: #fff;
        font-size: 56px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }

    p {
        color: #fff;
        font-size: 21px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: underline;
        outline: none;
        color: #fff;

        :hover {
            color: #5a42d2;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
